/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@/client";
import type { PutUploadDebtorCollectionImageMutationRequest, PutUploadDebtorCollectionImageMutationResponse, PutUploadDebtorCollectionImagePathParams, PutUploadDebtorCollectionImage400, PutUploadDebtorCollectionImage401, PutUploadDebtorCollectionImage403, PutUploadDebtorCollectionImage404 } from "../../models/PutUploadDebtorCollectionImage";
import type { RequestConfig, ResponseErrorConfig } from "@/client";
import { buildFormData } from "../../.kubb/config";

function getPutUploadDebtorCollectionImageUrl({ debtorCode, collectionId }: { debtorCode: PutUploadDebtorCollectionImagePathParams["debtorCode"]; collectionId: PutUploadDebtorCollectionImagePathParams["collectionId"] }) {
  const res = { method: 'PUT', url: `/api/v1/debtors/${debtorCode}/collections/${collectionId}/image` as const }  
  return res
}

/**
 * {@link /api/v1/debtors/:debtorCode/collections/:collectionId/image}
 */
export async function putUploadDebtorCollectionImage({ debtorCode, collectionId, data }: { debtorCode: PutUploadDebtorCollectionImagePathParams["debtorCode"]; collectionId: PutUploadDebtorCollectionImagePathParams["collectionId"]; data: PutUploadDebtorCollectionImageMutationRequest }, config: Partial<RequestConfig<PutUploadDebtorCollectionImageMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  const formData = buildFormData(requestData)  
  const res = await request<PutUploadDebtorCollectionImageMutationResponse, ResponseErrorConfig<PutUploadDebtorCollectionImage400 | PutUploadDebtorCollectionImage401 | PutUploadDebtorCollectionImage403 | PutUploadDebtorCollectionImage404>, PutUploadDebtorCollectionImageMutationRequest>({ method : "PUT", url : getPutUploadDebtorCollectionImageUrl({ debtorCode, collectionId }).url.toString(), data : formData as FormData, ... requestConfig })  
  return res.data
}